import React from 'react';
import { DriveItem } from '../types';

interface SelectedFilesProps {
  files: DriveItem[];
  onRemoveFile: (fileId: string) => void;
}

const SelectedFiles: React.FC<SelectedFilesProps> = ({ files, onRemoveFile }) => {
  if (files.length === 0) {
    return (
      <div className="no-files">
        <p>No files selected. Please select files from Google Drive.</p>
      </div>
    );
  }

  return (
    <div className="selected-files">
      <h3>Selected Files ({files.length})</h3>
      <ul className="file-list">
        {files.map((file) => (
          <li key={file.id} className="file-item">
            <span className="file-name">{file.name}</span>
            <button 
              className="remove-button"
              onClick={() => onRemoveFile(file.id)}
              aria-label={`Remove ${file.name}`}
            >
              &times;
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SelectedFiles; 